import React from 'react';
import Select from './common/Select';
import {dataColors,colorContrasts} from '../utils/constants';
import PlainButton from './common/PlainButton';
import Toggle from "react-toggle";
import { DropdownIndicator } from '../utils/dropdown-override';
import ToolTip from './common/ToolTip';
import SonificationSettingsComponent from './SonificationSettingsComponent.jsx'

class AccessibilitySettingsComponent extends React.Component {
    constructor(props) {
        super(props);
        let Dyn = this.props.Dyn,
            colorContrastOptions = Array.from(colorContrasts);
        if( Dyn.debugging ) {
            // Add test themes if in debugging mode ('theme.subtheme' format)
            Object.keys( Dyn.plotThemeColors.testThemes ).forEach( (testThemeKey, i) => {
                colorContrastOptions.push({ label : 'test '+testThemeKey, value: testThemeKey });
            });
        }
        this.state = {
            attributeContextMenu: this.props.Dyn.preferences.isAttributeContextMenu(),
            animateGraphs : this.props.Dyn.preferences.isAnimationOn(),
            dataColor : this.props.Dyn.preferences.getColorScheme(),
            colorContrast : this.props.Dyn.preferences.getTheme(),
            colorContrastOptions : colorContrastOptions,
        }
    }

    componentDidMount = () => {
        // Focus the panel
        this.refs.accessibilitySettingsPanel.focus();
    }

    onKeyPressed = (e) => {
        if(e.keyCode === 27) {
            // Focus close button on esc
            this.refs.closeButton.focus();
        }
    }

    handleClose = (event) => {
        // To close the current view
        this.props.onClose();
    }

    getLoc = (str) => {
        let Dyn = this.props.Dyn;
        return Dyn.loc( str );
    }

    handleClickAnimateGraphs = (value) => {
        if (value !== this.state.animateGraphs) {
            this.setState({
                animateGraphs : value
            },() => this.props.Dyn.preferences.setAnimationOn(value));
        }
    }

    handleClickAttributeContextMenu = (value) => {
        if (value !== this.state.attributeContextMenu) {
            this.setState({
                attributeContextMenu: value
            }, () => this.props.Dyn.preferences.setAttributeContextMenu(value))
        }
    }

    changeDataColors = obj => {
        this.setState({
            dataColor : obj.value
        },() => this.props.Dyn.preferences.setColorScheme( obj.value ));
    }

    changeColorContrast = obj => {
        let optionalSubTheme = obj.value.includes('.') ? obj.value : null,
            theme = obj.value.split('.')[0];
        this.props.switchTheme( theme, optionalSubTheme );
        this.setState({
            colorContrast : obj.value
        });
    }

    render = () => {
        return (
        <div className="tde-fill" ref="accessibilitySettingsPanel" onKeyDown={this.onKeyPressed} tabIndex="0" style={this.props.style}>
            <div className="tde-sliding-panel-header tde-divider-bottom">
                <div>
                    <span
                        className="tde-ml-2 tde-h6 tde-font-weight-bold"
                        role="heading"
                        aria-level="1">{ this.getLoc('ACCESSIBILITY CARD') }</span>
                </div>
                <PlainButton title="Close" ref="closeButton" aria-label={this.getLoc('Close Accessibility Card')} onClick={this.handleClose} className="tde-mx-2 tde-close-attr-settings"><i className="tde-i tde-i-remove"></i></PlainButton>
            </div>
            <div className="tde-sliding-panel-body tde-accessibility-settings-body tde-card-content-bg-color">
                <div className={this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3'}>
                    <div className="tde-d-flex tde-mt-3">
                        <p className="tde-label tde-flex-1 tde-font-weight-bold tde-pr-1">
                            {this.getLoc("Attribute Keyboard Support")}
                            <ToolTip tip={'Toggle attribute keyboard support to add or remove attributes to the x-axis, y-axis, and legend without using a mouse'} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1" aria-label={'Toggle attribute keyboard support to add or remove attributes to the x-axis, y-axis, and legend without using a mouse'}><span className="tde-sr-only">{'Toggle attribute keyboard support to add or remove attributes to the x-axis, y-axis, and legend without using a mouse'}</span></i></ToolTip>
                        </p>
                        <div style={{width:'70px'}}>
                            <Toggle
                                checked={this.state.attributeContextMenu}
                                className="black-toggle tde-float-right"
                                icons={false}
                                aria-label={`${this.getLoc("Attribute Keyboard Support")}, ${this.state.attributeContextMenu ? 'checked' : 'unchecked'}, checkbox`}
                                onChange={(e) => {
                                    this.handleClickAttributeContextMenu(
                                        e.target.checked
                                    );
                                }}
                            />
                        </div>
                    </div>

                    <div className="tde-d-flex tde-mt-3">
                        <p className="tde-label tde-flex-1 tde-font-weight-bold tde-pr-1">
                            {this.getLoc("Animate Graphs")}
                            <ToolTip tip={'Toggle graph animations to see the graphs change from one plot to another'} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1" aria-label={'Toggle graph animations to see the graphs change from one plot to another'}><span className="tde-sr-only">{'Toggle graph animations to see the graphs change from one plot to another'}</span></i></ToolTip>
                        </p>
                        <div>
                            <Toggle
                                checked={this.state.animateGraphs}
                                className="black-toggle tde-float-right"
                                icons={false}
                                aria-label={`${this.getLoc("Animate Graphs")}, ${this.state.animateGraphs ? 'checked' : 'unchecked'}, checkbox`}
                                onChange={(e) => {
                                    this.handleClickAnimateGraphs(
                                        e.target.checked
                                    );
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className="tde-my-4 tde-divider-top"></div>
                <div className={this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3'}>
                    <div className="tde-my-2 tde-s1-size tde-d-flex tde-align-center">
                        <p className="tde-m-0 tde-font-weight-bold">{this.getLoc('Data Colors')}<ToolTip tip={this.getLoc('Choose between data colors for visibility')} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1" aria-label={this.getLoc('Choose between data colors for visibility')}><span className="tde-sr-only">{this.getLoc('Choose between data colors for visibility')}</span></i></ToolTip></p>
                    </div>
                    <div className="tde-s1-size tde-d-flex tde-align-center">
                        <Select
                            Dyn={this.props.Dyn}
                            aria-label={this.getLoc('Choose between data colors for visibility')}
                            className="tde-input tde-flex-1 tde-select-input tde-input-select tde-data-colors tde-select-right"
                            isClearable={false}
                            value={dataColors.find(
                                (obj) => obj.value === this.state.dataColor
                            )}
                            options={dataColors}
                            // openMenuOnFocus
                            onChange={this.changeDataColors}
                            isSearchable={false}
                            tabSelectsValue={false}
                            placeholder={<div className='tde-select-placeholder'>{this.getLoc('Select')+'...'}</div>}
                            components={{
                                Option: ({ data, innerProps, children, innerRef, isSelected, isFocused }) => (
                                    <div
                                        className={'tde-select-option' + (isSelected ? ' tde-selected' :"") + (isFocused ? ' tde-focused' : '')}
                                        role="option"
                                        aria-selected={isSelected ? "true" : "false"}
                                        aria-label={data.title}
                                        title={data.title}
                                        {...innerProps}
                                        ref={innerRef}
                                    >
                                        <div className="tde-s1">{children}</div>
                                    </div>
                                ),
                                DropdownIndicator
                            }}
                        />

                    </div>
                    <div className="tde-my-2 tde-s1-size tde-d-flex tde-mt-3 tde-align-center">
                        <p className="tde-m-0 tde-font-weight-bold">
                            {this.getLoc('Color Contrast')}<ToolTip tip={this.getLoc('Choose between default or reverse contrast for visibility')} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1" aria-label={this.getLoc('Choose between default or reverse contrast for visibility')}><span className="tde-sr-only">{this.getLoc('Choose between default or reverse contrast for visibility')}</span></i></ToolTip>
                        </p>
                    </div>
                    <div className="tde-s1-size tde-d-flex tde-align-center">
                        <Select
                            Dyn={this.props.Dyn}
                            aria-label={this.getLoc('Choose between default or reverse contrast for visibility')}
                            className="ttde-input tde-flex-1 tde-select-input tde-input-select tde-select-right"
                            isClearable={false}
                            value={{
                                label : this.getLoc(this.state.colorContrastOptions.find(obj => obj.value === this.state.colorContrast).label),
                                value : this.state.colorContrast
                            }}
                            options={this.state.colorContrastOptions}
                            // openMenuOnFocus
                            isSearchable={false}
                            tabSelectsValue={false}
                            onChange={this.changeColorContrast}
                            placeholder={<div className='tde-select-placeholder'>{this.getLoc('Select')+'...'}</div>}
                            components={{
                                Option: ({ data, innerProps, children, innerRef, isSelected, isFocused }) => (
                                    <div
                                        className={'tde-select-option' + (isSelected ? ' tde-selected' :"") + (isFocused ? ' tde-focused' : '')}
                                        role="option"
                                        aria-selected={isSelected ? "true" : "false"}
                                        title={data.title}
                                        {...innerProps}
                                        ref={innerRef}
                                    >
                                        <div className="tde-s1">{this.getLoc(children)}</div>
                                    </div>
                                ),
                                DropdownIndicator
                            }}
                        />
                    </div>
                    </div>
                    <div className="tde-my-4 tde-divider-top"></div>
                    {
                <SonificationSettingsComponent
                    Dyn = {this.props.Dyn}
                    key='sonification-comp' />}
                    {/* play button, which can be changed to puase / restart button */}
                </div>
            </div>
        );
    }
}

export default AccessibilitySettingsComponent
